import ModuleReview from 'shared/components/organisms/ModuleReview/ModuleReview';

export default ModuleReview;
